module.exports = __webpack_public_path__ + "new-5455795b/template-7-preview-d132bb2d8dc18513da52a98cbe052aa0.jpg";